/**
 * Bezorgkosten als cart-regel (zonder CCS).
 * Rekent uit vendor + Dealerprijs-tags; sync variant van uf-bezorgkosten.
 */
(function () {
  "use strict";

  var FREE_FROM = 1499;
  var BLOCK_PROFIT = 50;
  var BLOCK_DISCOUNT = 12.5;
  var PLINTEN = 30;
  var ACCESSOIRES = 7.95;
  var SAMPLES_PPC = 9.5;
  var PVC_FALLBACK = 70;
  /** Harde max voor vloer-bezorging (hoogste merktarief). Aantal op de fee-regel is altijd 1. */
  var MAX_FLOOR_SHIP = 70;
  /** Laatste redmiddel als merktarief/map faalt (checkout-verzending is €0). */
  var LAST_RESORT = 69;
  var FEE_HANDLE = "uf-bezorgkosten";
  var MAP_EMERGENCY = {
    byCents: {
      "7000": 55377886576977,
    },
  };
  var PROP_KEY = "_uf_shipping_fee";

  var BRAND_RATES = {
    tarkett: 45,
    ambiant: 70,
    moduleo: 70,
    beautifloor: 70,
    mflor: 70,
    solcora: 70,
    belakos: 55,
    aspecta: 50,
    otium: 50,
    "douwes dekker": 50,
  };

  var mapPromise = null;
  var productCache = {};
  var syncing = false;
  var debounceTimer = null;
  /** True alleen tijdens onze eigen cart-mutaties (niet qty-UI blokkeren). */
  var ignoreOwnCartAjax = false;

  function money2(n) {
    return Math.round(n * 100) / 100;
  }

  function brandBase(vendor) {
    var key = String(vendor || "")
      .trim()
      .toLowerCase();
    if (!key) return null;
    if (key.indexOf("otium") === 0) return BRAND_RATES.otium;
    if (key.indexOf("douwes") === 0) return BRAND_RATES["douwes dekker"];
    return BRAND_RATES[key] != null ? BRAND_RATES[key] : null;
  }

  function brandKnown(vendor) {
    return brandBase(vendor) != null;
  }

  function profitMarginB(dealerEx, sellIncl) {
    return money2(sellIncl - sellIncl * 0.21 - dealerEx);
  }

  function parseDealerTags(tags) {
    if (!tags || !tags.length) return null;
    for (var i = 0; i < tags.length; i++) {
      var t = String(tags[i] || "").trim();
      var lower = t.toLowerCase();
      if (lower.indexOf("bruto dealerprijs") === 0) continue;
      if (lower.indexOf("dealerprijs") !== 0) continue;
      var idx = t.indexOf(":");
      if (idx < 0) continue;
      var n = parseFloat(
        t
          .slice(idx + 1)
          .trim()
          .replace(",", ".")
          .replace(/[^\d.-]/g, "")
      );
      if (isFinite(n) && n > 0) return money2(n);
    }
    return null;
  }

  function isFloorProduct(vendor, tags, productType) {
    var blob = (
      String(vendor || "") +
      " " +
      String(productType || "") +
      " " +
      (tags || []).join(" ")
    ).toLowerCase();
    if (/segment:\s*vloer|assortiment:\s*pvc|pvc vloer|productlijn:\s*pvc/.test(blob)) {
      return true;
    }
    if (/segment:\s*plint|productlijn:\s*rand|accessoires/.test(blob)) {
      return false;
    }
    return brandKnown(vendor);
  }

  function isPlinten(tags, productType, title) {
    var blob = (
      String(productType || "") +
      " " +
      (tags || []).join(" ") +
      " " +
      String(title || "")
    ).toLowerCase();
    return /plint|profiel|randafwerking/.test(blob);
  }

  function isPpcVendor(vendor) {
    var key = String(vendor || "")
      .trim()
      .toLowerCase();
    if (!key) return false;
    if (key.indexOf("otium") === 0 || key.indexOf("douwes") === 0) return true;
    if (key === "aspecta" || key.indexOf("aspecta") === 0) return true;
    if (key === "ppc" || key.indexOf("douwes dekker") >= 0) return true;
    return false;
  }

  function isSample(item, tags, productType) {
    var blob = (
      String(item.product_title || "") +
      " " +
      String(item.title || "") +
      " " +
      String(item.variant_title || "") +
      " " +
      String(item.sku || "") +
      " " +
      String(productType || "") +
      " " +
      (tags || []).join(" ")
    ).toLowerCase();
    if (
      /proefmonster|kleurstaal|kleurstalen|gratis\s*proef|\bsample\b/.test(blob)
    ) {
      return true;
    }
    if (/\bproef\b/.test(blob) || /[-_]proef\b/.test(blob)) return true;
    if (/\bmonster\b/.test(blob) && !/vloer/.test(blob)) return true;
    return false;
  }

  function isFeeItem(item) {
    if (!item) return false;
    if (item.handle === FEE_HANDLE) return true;
    var p = item.properties || {};
    return p[PROP_KEY] === "1" || p[PROP_KEY] === 1;
  }

  function merchandiseCents(cart) {
    var total = 0;
    (cart.items || []).forEach(function (item) {
      if (isFeeItem(item)) return;
      total += item.final_line_price != null ? item.final_line_price : item.line_price;
    });
    return total;
  }

  function loadMap() {
    if (mapPromise) return mapPromise;
    var url =
      (window.Shopify && Shopify.cdnHost
        ? "//" + Shopify.cdnHost
        : "") || "";
    // Theme asset via relative path from Shopify CDN
    var assetUrl =
      (document.querySelector('script[src*="uf-shipping-fee.js"]') || {})
        .src || "";
    var base = assetUrl.replace(/uf-shipping-fee\.js.*$/, "");
    mapPromise = fetch(base + "uf-shipping-fee-variants.json", {
      credentials: "same-origin",
    })
      .then(function (r) {
        if (!r.ok) throw new Error("variant map " + r.status);
        return r.json();
      })
      .catch(function (err) {
        console.warn("[uf-shipping-fee] map load failed", err);
        mapPromise = null;
        return null;
      });
    return mapPromise;
  }

  function fetchProduct(handle) {
    if (!handle) return Promise.resolve(null);
    if (productCache[handle]) return productCache[handle];
    productCache[handle] = fetch("/products/" + encodeURIComponent(handle) + ".js", {
      credentials: "same-origin",
    })
      .then(function (r) {
        if (!r.ok) return null;
        return r.json();
      })
      .catch(function () {
        return null;
      });
    return productCache[handle];
  }

  function quoteFromCart(cart, productsByHandle) {
    var merch = merchandiseCents(cart) / 100;
    if (merch >= FREE_FROM) {
      return { amount: 0, free: true };
    }

    var floors = [];
    var hasPlinten = false;
    var hasOther = false;
    var samples = [];

    (cart.items || []).forEach(function (item) {
      if (isFeeItem(item)) return;
      var handle = item.handle;
      var p = productsByHandle[handle] || {};
      var tags = p.tags
        ? typeof p.tags === "string"
          ? p.tags.split(",").map(function (t) {
              return t.trim();
            })
          : p.tags
        : [];
      var vendor = p.vendor || item.vendor || "";
      var productType = p.type || p.product_type || "";
      var qty = item.quantity || 1;
      var sellIncl = (item.final_price != null ? item.final_price : item.price) / 100;
      if (isSample(item, tags, productType)) {
        samples.push({ vendor: vendor, qty: qty });
        return;
      }
      if (isFloorProduct(vendor, tags, productType)) {
        floors.push({
          vendor: vendor,
          sellIncl: sellIncl,
          qty: qty,
          dealer: parseDealerTags(tags),
        });
      } else if (isPlinten(tags, productType, item.product_title || item.title)) {
        hasPlinten = true;
      } else {
        hasOther = true;
      }
    });

    if (floors.length) {
      var maxBase = 0;
      var profitB = 0;
      floors.forEach(function (f) {
        var base = brandBase(f.vendor);
        if (base == null) base = PVC_FALLBACK;
        if (base > maxBase) maxBase = base;
        if (f.dealer != null && f.dealer > 0) {
          profitB += profitMarginB(f.dealer, f.sellIncl) * f.qty;
        }
      });
      profitB = money2(profitB);
      var blocks = Math.floor(Math.max(0, profitB) / BLOCK_PROFIT);
      var discount = money2(blocks * BLOCK_DISCOUNT);
      var cap = Math.min(maxBase, MAX_FLOOR_SHIP);
      var amount = money2(Math.min(cap, Math.max(0, maxBase - discount)));
      return { amount: amount, free: false, cap: cap };
    }

    if (hasPlinten) return { amount: PLINTEN, free: false };
    if (hasOther) return { amount: ACCESSOIRES, free: false };

    if (samples.length) {
      var hasPpcSample = samples.some(function (s) {
        return isPpcVendor(s.vendor);
      });
      if (hasPpcSample) return { amount: SAMPLES_PPC, free: false };
      return { amount: 0, free: true };
    }

    return { amount: 0, free: true };
  }

  function cartHasFloorItems(cart, productsByHandle) {
    var found = false;
    (cart.items || []).forEach(function (item) {
      if (isFeeItem(item)) return;
      var p = (productsByHandle && productsByHandle[item.handle]) || {};
      var tags = p.tags
        ? typeof p.tags === "string"
          ? p.tags.split(",").map(function (t) {
              return t.trim();
            })
          : p.tags
        : [];
      var productType = p.type || p.product_type || "";
      if (isSample(item, tags, productType)) return;
      if (isFloorProduct(p.vendor || item.vendor, tags, productType)) {
        found = true;
        return;
      }
      var blob = (
        String(item.product_title || item.title || "") +
        " " +
        String(item.handle || "") +
        " " +
        String(item.vendor || p.vendor || "")
      ).toLowerCase();
      if (
        /pvc|vloer|moduleo|tarkett|mflor|solcora|beautifloor|ambiant|belakos|aspecta|otium|douwes/.test(
          blob
        )
      ) {
        found = true;
      }
    });
    return found;
  }

  function nearestCents(amount, byCents, capCents) {
    var target = Math.round(amount * 100);
    var cap =
      typeof capCents === "number" && isFinite(capCents) ? capCents : Infinity;
    var keys = Object.keys(byCents)
      .map(function (k) {
        return parseInt(k, 10);
      })
      .filter(function (k) {
        return isFinite(k) && k <= cap;
      });
    if (!keys.length) {
      keys = Object.keys(byCents).map(function (k) {
        return parseInt(k, 10);
      });
    }
    if (byCents[String(target)] != null && target <= cap) return target;
    var best = keys[0];
    var bestDiff = Math.abs(best - target);
    keys.forEach(function (k) {
      var d = Math.abs(k - target);
      if (d < bestDiff) {
        best = k;
        bestDiff = d;
      }
    });
    return best;
  }

  function removeFeeLines(cart) {
    var updates = {};
    (cart.items || []).forEach(function (item) {
      if (isFeeItem(item)) updates[item.key || item.id] = 0;
    });
    if (!Object.keys(updates).length) return Promise.resolve(cart);
    return fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      credentials: "same-origin",
      body: JSON.stringify({ updates: updates }),
    }).then(function (r) {
      return r.json();
    });
  }

  /** Altijd qty 1 + unieke property → aparte cartregel (nooit qty optellen). */
  function addFee(variantId) {
    var props = {};
    props[PROP_KEY] = "1";
    props._uf_fee_line = String(Date.now());
    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      credentials: "same-origin",
      body: JSON.stringify({
        items: [
          {
            id: variantId,
            quantity: 1,
            properties: props,
          },
        ],
      }),
    }).then(function (r) {
      return r.json();
    });
  }

  function cartPageNeedsReload(cart) {
    if (!document.querySelector(".uf-cart-page")) return false;
    var rows = document.querySelectorAll(".uf-cart-page__line").length;
    var items = (cart && cart.items) || [];
    if (rows !== items.length) return true;
    var feeInDom = !!document.querySelector(
      '.uf-cart-page__line[data-uf-shipping-fee="1"]'
    );
    var feeInCart = items.some(isFeeItem);
    return feeInDom !== feeInCart;
  }

  function withOwnCartAjax(promiseFactory) {
    ignoreOwnCartAjax = true;
    window.__ufShippingFeeBusy = true;
    return Promise.resolve()
      .then(promiseFactory)
      .then(
        function (v) {
          ignoreOwnCartAjax = false;
          window.__ufShippingFeeBusy = false;
          return v;
        },
        function (err) {
          ignoreOwnCartAjax = false;
          window.__ufShippingFeeBusy = false;
          throw err;
        }
      );
  }

  /** Ververs drawer (niet tijdens qty-update); cartpagina alleen bij ontbrekende fee-regel. */
  function refreshCartUi(changed, cart) {
    if (typeof window.free_shipping_update === "function") {
      try {
        window.free_shipping_update();
      } catch (e) {}
    }
    document.dispatchEvent(new CustomEvent("uf:shipping-fee-synced"));

    if (!changed) return;

    var onCartPage = !!document.querySelector(".uf-cart-page");
    if (onCartPage) {
      // Alleen reload als de fee-regel in de HTML ontbreekt/verschilt — niet bij elke qty-klik
      if (cartPageNeedsReload(cart)) {
        window.location.reload();
      } else if (cart && typeof window.ufCartPageUpdatePrices === "function") {
        window.ufCartPageUpdatePrices(cart);
      }
      return;
    }

    // Drawer: één hertekening, ná qty-flow (debounced sync)
    if (typeof window.ajaxCart !== "undefined" && typeof ajaxCart.load === "function") {
      ignoreOwnCartAjax = true;
      window.__ufShippingFeeBusy = true;
      try {
        ajaxCart.load();
      } catch (e) {}
      setTimeout(function () {
        ignoreOwnCartAjax = false;
        window.__ufShippingFeeBusy = false;
      }, 500);
    }
  }

  function syncCart() {
    if (syncing || ignoreOwnCartAjax) return Promise.resolve();
    syncing = true;

    return Promise.all([
      fetch("/cart.js", { credentials: "same-origin" }).then(function (r) {
        return r.json();
      }),
      loadMap(),
    ])
      .then(function (pair) {
        var cart = pair[0];
        var map =
          pair[1] && pair[1].byCents ? pair[1] : MAP_EMERGENCY;
        if (!cart || !map || !map.byCents) {
          return { changed: false, cart: cart };
        }

        var handles = {};
        (cart.items || []).forEach(function (item) {
          if (!isFeeItem(item) && item.handle) handles[item.handle] = true;
        });

        return Promise.all(
          Object.keys(handles).map(function (h) {
            return fetchProduct(h).then(function (p) {
              return { handle: h, product: p };
            });
          })
        ).then(function (rows) {
          var byHandle = {};
          rows.forEach(function (row) {
            byHandle[row.handle] = row.product || {};
          });

          var quote = quoteFromCart(cart, byHandle);
          var merch = merchandiseCents(cart) / 100;
          if (
            merch < FREE_FROM &&
            !quote.free &&
            (!quote.amount || quote.amount <= 0) &&
            cartHasFloorItems(cart, byHandle)
          ) {
            quote = { amount: LAST_RESORT, free: false, cap: MAX_FLOOR_SHIP };
          }
          var capCents = Math.round(
            (quote.cap != null ? quote.cap : MAX_FLOOR_SHIP) * 100
          );
          if (quote.amount > capCents / 100) {
            quote.amount = capCents / 100;
          }
          var wantCents = nearestCents(quote.amount, map.byCents, capCents);
          var wantVariant = map.byCents[String(wantCents)];
          var wantFee = quote.amount > 0 && !!wantVariant;

          var feeItems = (cart.items || []).filter(isFeeItem);
          var feeOverCap = feeItems.some(function (item) {
            var line =
              item.final_line_price != null
                ? item.final_line_price
                : item.line_price;
            return Number(item.quantity) !== 1 || line > capCents;
          });
          var matching = feeItems.filter(function (item) {
            return (
              Number(item.id) === Number(wantVariant) &&
              Number(item.quantity) === 1 &&
              feeItems.length === 1 &&
              !feeOverCap
            );
          });

          if (wantFee && matching.length === 1) {
            return { changed: false, cart: cart };
          }

          return withOwnCartAjax(function () {
            return removeFeeLines(cart)
              .then(function () {
                if (!wantFee) return null;
                return addFee(wantVariant);
              })
              .then(function () {
                return fetch("/cart.js", { credentials: "same-origin" }).then(
                  function (r) {
                    return r.json();
                  }
                );
              })
              .then(function (fresh) {
                return { changed: true, cart: fresh };
              });
          });
        });
      })
      .then(function (result) {
        syncing = false;
        refreshCartUi(!!(result && result.changed), result && result.cart);
      })
      .catch(function (err) {
        syncing = false;
        ignoreOwnCartAjax = false;
        window.__ufShippingFeeBusy = false;
        console.warn("[uf-shipping-fee] sync failed", err);
      });
  }

  function scheduleSync(delayMs) {
    if (ignoreOwnCartAjax || syncing) return;
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function () {
      syncCart();
    }, typeof delayMs === "number" ? delayMs : 450);
  }

  // Expose merchandise helper for free_shipping_update
  window.ufShippingFeeMerchandiseCents = function (cart) {
    return merchandiseCents(cart);
  };
  window.ufShippingFeeSync = scheduleSync;

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      scheduleSync(200);
    });
  } else {
    scheduleSync(200);
  }

  document.addEventListener("cart:updated", function () {
    scheduleSync(450);
  });
  document.addEventListener("uf:cart-updated", function () {
    scheduleSync(450);
  });

  function bindJqueryHooks() {
    if (!window.jQuery) return;
    var $ = window.jQuery;
    // Geen ajaxComplete op cart/change — dat raced met qty (isUpdating).
    // Alleen ná afgeronde ajax-cart events, met delay zodat buildCart klaar is.
    $(document.body).on("afterAddItem.ajaxCart", function () {
      if (ignoreOwnCartAjax) return;
      scheduleSync(500);
    });
    $(document.body).on("afterChangeItem.ajaxCart", function () {
      if (ignoreOwnCartAjax) return;
      scheduleSync(700);
    });
  }

  if (window.jQuery) {
    bindJqueryHooks();
  } else {
    document.addEventListener("DOMContentLoaded", bindJqueryHooks);
  }
})();
